export class ExitSurvey {
  id: number;
  course_enrolment_id: number;
  recommendation_chance: number;
  future_watch_chance: number;
  satisfaction_score: number;
  created_at: Date;
  updated_at: Date;
}
